/* LSL · Menu interactif : comportement (sections/lsl-nav.liquid, styles lsl-nav.css).
   Ordinateur : lame lumineuse sous l'onglet survolé, panneau qui change de place et de taille, aperçu du produit
   (image, prix) ou de la collection (4 produits chargés à la demande) survolés, navigation au clavier.
   Mobile : tiroir, sous-menus qui glissent, glisser vers la droite pour revenir / vers la gauche pour fermer,
   recherche en direct. Les liens du menu sont tous dans le HTML ; ce script n'ajoute que l'aperçu et les résultats. */
(() => {
  'use strict';
  if (window.__lslNav) return;
  window.__lslNav = true;

  const html = document.documentElement;
  const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const mqD = matchMedia('(min-width: 1200px)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const isD = () => mqD.matches;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (src, w) => src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
  const raf2 = fn => requestAnimationFrame(() => requestAnimationFrame(fn));
  const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h13M13 6l6 6-6 6"/></svg>';
  const GRID = '<svg viewBox="0 0 24 24" focusable="false"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>';

  let nav, bg, items = [], cur = null, openLi = null, lastFocus = null, tOpen = 0, tClose = 0;

  const panelOf = li => li && li.querySelector(':scope > .lsl-nv__p');
  const togOf = li => li && li.querySelector(':scope > .lsl-nv__tg');
  const setExp = (li, v) => { const t = togOf(li); if (t) t.setAttribute('aria-expanded', v ? 'true' : 'false'); };
  const topLi = el => el && el.closest('.lsl-nv__l1 > .lsl-nv__i');
  const activeLi = () => items.find(li => li.classList.contains('is-active') && li.offsetParent);

  /* ================= Ordinateur ================= */

  /* Lame : s'allume depuis la gauche au premier survol, puis glisse d'un onglet à l'autre */
  function blade(li) {
    const t = li && li.querySelector('.lsl-nv__t');
    if (!t || !isD()) { nav.classList.remove('is-lit'); return; }
    const nr = nav.getBoundingClientRect(), r = t.getBoundingClientRect();
    const first = !nav.classList.contains('is-lit');
    if (first) nav.classList.add('no-tr');
    nav.style.setProperty('--bx', (r.left - nr.left).toFixed(1) + 'px');
    nav.style.setProperty('--bw', r.width.toFixed(1) + 'px');
    if (first) { void nav.offsetWidth; nav.classList.remove('no-tr'); }
    nav.classList.add('is-lit');
  }
  const rest = () => blade(activeLi());

  function place(li) {
    const p = panelOf(li); if (!p) return;
    const nr = nav.getBoundingClientRect();
    const a = li.querySelector('.lsl-nv__a').getBoundingClientRect();
    const w = p.offsetWidth, h = p.offsetHeight;
    const cx = a.left + a.width / 2 - nr.left;
    const x = Math.max(16, Math.min(cx - w / 2, nr.width - w - 16));
    p.style.setProperty('--x', x + 'px');
    bg.style.setProperty('--x', x + 'px');
    bg.style.setProperty('--w', w + 'px');
    bg.style.setProperty('--h', (h - 10) + 'px');
    bg.style.setProperty('--cx', Math.max(26, Math.min(cx - x, w - 26)) + 'px');
  }

  function openD(li) {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!li || cur === li) return;
    const p = panelOf(li); if (!p) return;
    const prev = cur;
    if (prev) {
      const pp = panelOf(prev), right = items.indexOf(li) > items.indexOf(prev);
      prev.classList.remove('is-open'); setExp(prev, false);
      pp.classList.remove('is-on', 'to-l', 'to-r'); pp.classList.add(right ? 'to-l' : 'to-r');
      setTimeout(() => pp.classList.remove('to-l', 'to-r'), 380);
      p.classList.add('no-tr', right ? 'from-r' : 'from-l');
    } else {
      nav.classList.add('is-first');
    }
    cur = li;
    li.classList.add('is-open'); setExp(li, true);
    place(li);
    void p.offsetWidth;
    p.classList.remove('no-tr', 'from-r', 'from-l', 'to-l', 'to-r');
    p.classList.add('is-on');
    nav.classList.add('is-dd');
    if (!prev) raf2(() => nav.classList.remove('is-first'));
    defaultPv(p);
    blade(li);
  }

  function closeD() {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!cur) return;
    const p = panelOf(cur);
    cur.classList.remove('is-open'); setExp(cur, false);
    p.classList.remove('is-on');
    cur = null;
    nav.classList.remove('is-dd');
  }

  /* Aperçu à droite du panneau */
  const cache = {};
  const loadColl = h => cache[h] || (cache[h] = fetch(R + 'collections/' + encodeURIComponent(h) + '/products.json?limit=4')
    .then(r => (r.ok ? r.json() : { products: [] }))
    .then(d => (d.products || []).map(p => ({ t: p.title, u: R + 'products/' + p.handle, i: p.images && p.images[0] ? p.images[0].src : '' })))
    .catch(() => []));

  function pv(row) {
    const p = row.closest('.lsl-nv__p'), box = p && p.querySelector('[data-nv-pv]');
    if (!box || box._row === row) return;
    const a = row.querySelector('.lsl-nv__rt'), k = row.dataset.k;
    if (k === 'product' && row.dataset.img) {
      box.innerHTML = '<div class="lsl-nv__pvc"><div class="lsl-nv__pvi"><img src="' + esc(row.dataset.img) + '" alt="" decoding="async"></div>' +
        '<p class="lsl-nv__pvt">' + esc(a.textContent.trim()) + '</p>' +
        '<p class="lsl-nv__pvm"><span>' + (row.dataset.p ? '<b>' + esc(row.dataset.p) + '</b>' : '') + (row.dataset.c ? '<s>' + esc(row.dataset.c) + '</s>' : '') + '</span><span>Voir la fiche →</span></p></div>';
    } else if (k === 'collection' && row.dataset.h) {
      const n = row.dataset.n;
      box.innerHTML = '<div class="lsl-nv__pvc"><p class="lsl-nv__pvh"><span>Aperçu</span><span>' + (n ? esc(n) + ' modèles' : '') + '</span></p>' +
        '<div class="lsl-nv__pvg">' + '<a><i></i><i></i></a>'.repeat(4) + '</div></div>';
      loadColl(row.dataset.h).then(list => {
        if (box._row !== row) return;
        const g = box.querySelector('.lsl-nv__pvg'); if (!g) return;
        g.innerHTML = list.length
          ? list.slice(0, 4).map(x => '<a href="' + esc(x.u) + '" tabindex="-1"><img src="' + esc(sized(x.i, 240)) + '" alt="" loading="lazy" decoding="async"><span>' + esc(x.t) + '</span></a>').join('')
          : '';
      });
    } else return;
    box.dataset.href = a.href;
    box._row = row;
    box.classList.add('is-on');
    box.parentElement.classList.add('has-pv');
    p.querySelectorAll('.lsl-nv__r.is-pv').forEach(r => r.classList.remove('is-pv'));
    row.classList.add('is-pv');
  }

  function defaultPv(p) {
    const box = p.querySelector('[data-nv-pv]'); if (!box) return;
    if (p.querySelector('.lsl-nv__promo')) {
      box.classList.remove('is-on'); box._row = null; box.parentElement.classList.remove('has-pv');
      p.querySelectorAll('.lsl-nv__r.is-pv').forEach(r => r.classList.remove('is-pv'));
      return;
    }
    if (box._row) return;
    const first = p.querySelector('.lsl-nv__r[data-k="product"][data-img], .lsl-nv__r[data-h]');
    if (first) pv(first);
  }

  /* ================= Mobile ================= */

  function openM() {
    if (isD() || nav.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    nav.classList.add('is-open'); html.classList.add('lsl-nv-on');
    document.querySelectorAll('[aria-controls="lsl-nav"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => { const c = nav.querySelector('[data-nv-close]'); if (c) c.focus({ preventScroll: true }); }, 80);
  }
  function closeM(noFocus) {
    if (!nav.classList.contains('is-open')) return;
    nav.classList.remove('is-open'); html.classList.remove('lsl-nv-on');
    document.querySelectorAll('[aria-controls="lsl-nav"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    closeP(true); clearQ();
    if (!noFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function openP(li) {
    if (!panelOf(li)) return;
    if (openLi && openLi !== li) { openLi.classList.remove('is-open'); setExp(openLi, false); }
    openLi = li; li.classList.add('is-open'); setExp(li, true); nav.classList.add('has-p');
    panelOf(li).scrollTop = 0;
    setTimeout(() => { const b = panelOf(li).querySelector('[data-nv-back]'); if (b) b.focus({ preventScroll: true }); }, 90);
  }
  function closeP(silent) {
    if (!openLi) return;
    const li = openLi; openLi = null;
    li.classList.remove('is-open'); setExp(li, false); nav.classList.remove('has-p');
    if (!silent) setTimeout(() => li.querySelector('.lsl-nv__a').focus({ preventScroll: true }), 60);
  }

  function trap(e) {
    const ok = el => {
      if (!el.getClientRects().length || getComputedStyle(el).visibility === 'hidden') return false;
      const inMain = el.closest('.lsl-nv__main');
      if (inMain && nav.classList.contains('has-q')) return false;
      if (inMain && openLi && !el.closest('.lsl-nv__i.is-open > .lsl-nv__p')) return false;
      return true;
    };
    const f = [...nav.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select')].filter(ok);
    if (!f.length) return;
    const i = f.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
  }

  /* Recherche en direct */
  let q, qx, res, st, tq = 0, ctrl = null, lastQ = '';
  const fmt = v => {
    const c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(html.lang || 'fr-FR', { style: 'currency', currency: c }).format(parseFloat(v)); } catch (_) { return esc(v); }
  };
  function clearQ() {
    if (!q) return;
    clearTimeout(tq); if (ctrl) ctrl.abort();
    q.value = ''; qx.hidden = true; lastQ = '';
    nav.classList.remove('has-q'); res.innerHTML = ''; st.textContent = '';
  }
  async function search(v) {
    if (v === lastQ) return;
    lastQ = v;
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    const u = R + 'search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
    let d;
    try { d = await (await fetch(u, { signal: ctrl.signal })).json(); } catch (_) { return; }
    if (v !== lastQ) return;
    const r = (d.resources && d.resources.results) || {}, ps = r.products || [], cs = (r.collections || []).slice(0, 3);
    const all = '<a class="lsl-nv__rall" href="' + R + 'search?q=' + encodeURIComponent(v) + '&amp;options%5Bprefix%5D=last">Voir tous les résultats ' + ARROW + '</a>';
    nav.classList.add('has-q');
    if (!ps.length && !cs.length) {
      res.innerHTML = '<p class="lsl-nv__r0">Rien trouvé pour « ' + esc(v) + ' ». Essaie un personnage (Vador, Luke…), une couleur ou « NeoPixel ».</p>' + all;
      st.textContent = 'Aucun résultat';
      return;
    }
    const prow = p => {
      const cmp = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? ' <s>' + fmt(p.compare_at_price_max) + '</s>' : '';
      const img = p.image ? '<img class="lsl-nv__th" src="' + esc(sized(p.image, 112)) + '" alt="" loading="lazy" decoding="async">' : '<span class="lsl-nv__th lsl-nv__th--i" aria-hidden="true">' + GRID + '</span>';
      return '<li class="lsl-nv__r">' + img + '<span class="lsl-nv__rx"><a class="lsl-nv__rt" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="lsl-nv__rp">' + fmt(p.price) + cmp + '</span></span></li>';
    };
    const crow = c => '<li class="lsl-nv__r"><span class="lsl-nv__th lsl-nv__th--i" aria-hidden="true">' + GRID + '</span><span class="lsl-nv__rx"><a class="lsl-nv__rt" href="' + esc(c.url) + '">' + esc(c.title) + '</a></span></li>';
    res.innerHTML =
      (ps.length ? '<p class="lsl-nv__rh">Produits</p><ul role="list">' + ps.map(prow).join('') + '</ul>' : '') +
      (cs.length ? '<p class="lsl-nv__rh" style="margin-top:18px">Collections</p><ul role="list">' + cs.map(crow).join('') + '</ul>' : '') + all;
    res.scrollTop = 0;
    st.textContent = ps.length + ' produit' + (ps.length > 1 ? 's' : '') + (cs.length ? ' et ' + cs.length + ' collection' + (cs.length > 1 ? 's' : '') : '');
  }

  /* ================= Branchements ================= */

  function bind(n) {
    nav = n; bg = n.querySelector('.lsl-nv__bg');
    items = [...n.querySelectorAll('.lsl-nv__l1 > .lsl-nv__i')];
    cur = null; openLi = null;
    q = n.querySelector('[data-nv-q]'); qx = n.querySelector('[data-nv-qx]'); res = n.querySelector('[data-nv-res]'); st = n.querySelector('[data-nv-st]');

    n.addEventListener('pointerover', e => {
      if (!isD() || e.pointerType === 'touch') return;
      const li = topLi(e.target); if (!li) return;
      clearTimeout(tClose);
      if (e.target.closest('.lsl-nv__p')) { const row = e.target.closest('.lsl-nv__r'); if (row) pv(row); return; }
      blade(li);
      clearTimeout(tOpen);
      if (li.classList.contains('has-p')) tOpen = setTimeout(() => openD(li), cur ? 40 : 90);
      else if (cur) tOpen = setTimeout(closeD, 170);
    });
    n.addEventListener('pointerleave', e => {
      if (!isD() || e.pointerType === 'touch') return;
      clearTimeout(tOpen);
      tClose = setTimeout(() => { closeD(); rest(); }, 280);
    });
    n.addEventListener('pointerenter', () => clearTimeout(tClose));

    /* Effet de relief sur l'image de l'aperçu */
    n.addEventListener('pointermove', e => {
      const im = e.target.closest && e.target.closest('.lsl-nv__pvi'); if (!im || !fine.matches) return;
      const r = im.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      im.style.setProperty('--rx', (x * 16).toFixed(1) + 'deg'); im.style.setProperty('--ry', (-y * 16).toFixed(1) + 'deg');
      im.style.setProperty('--gx', ((x + .5) * 100).toFixed(0) + '%'); im.style.setProperty('--gy', ((y + .5) * 100).toFixed(0) + '%');
    }, { passive: true });
    n.addEventListener('pointerout', e => {
      const im = e.target.closest && e.target.closest('.lsl-nv__pvi');
      if (im && !im.contains(e.relatedTarget)) ['--rx', '--ry', '--gx', '--gy'].forEach(v => im.style.removeProperty(v));
    });

    n.addEventListener('click', e => {
      const tg = e.target.closest('.lsl-nv__tg'), a = e.target.closest('.lsl-nv__a');
      if (e.target.closest('[data-nv-close]')) { closeM(); return; }
      if (isD()) {
        if (tg) { e.preventDefault(); const li = tg.parentElement; if (cur === li) { closeD(); rest(); } else openD(li); return; }
        if (a && !fine.matches) { const li = a.parentElement; if (li.classList.contains('has-p') && cur !== li) { e.preventDefault(); openD(li); return; } }
        const box = e.target.closest('[data-nv-pv]');
        if (box && box.dataset.href && !e.target.closest('a')) location.href = box.dataset.href;
        return;
      }
      if (e.target.closest('[data-nv-back]')) { closeP(); return; }
      if (tg || (a && a.parentElement.classList.contains('has-p'))) { e.preventDefault(); openP((tg || a).parentElement); }
    });

    n.addEventListener('keydown', e => {
      if (isD()) {
        const tg = e.target.closest('.lsl-nv__tg');
        if (tg && e.key === 'ArrowDown') {
          e.preventDefault(); openD(tg.parentElement);
          const f = panelOf(tg.parentElement).querySelector('a[href]'); if (f) setTimeout(() => f.focus(), 40);
        }
        const a = e.target.closest('.lsl-nv__l1 > .lsl-nv__i > .lsl-nv__a');
        if (a && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
          const vis = items.filter(li => li.offsetParent).map(li => li.querySelector('.lsl-nv__a'));
          const i = vis.indexOf(a); e.preventDefault();
          vis[(i + (e.key === 'ArrowRight' ? 1 : -1) + vis.length) % vis.length].focus();
        }
      } else if (e.key === 'Tab' && n.classList.contains('is-open')) trap(e);
    });

    n.addEventListener('focusin', e => {
      if (!isD()) return;
      const li = topLi(e.target); if (!li) return;
      if (e.target.closest('.lsl-nv__p')) { const row = e.target.closest('.lsl-nv__r'); if (row) pv(row); return; }
      blade(li);
      if (cur && cur !== li) closeD();
    });
    n.addEventListener('focusout', e => { if (isD() && cur && !n.contains(e.relatedTarget)) { closeD(); rest(); } });

    /* Glisser : vers la gauche pour fermer le tiroir, vers la droite pour revenir */
    let drag = null;
    n.addEventListener('touchstart', e => {
      if (isD() || !n.classList.contains('is-open') || e.touches.length > 1) return;
      if (e.target.closest('.lsl-nv__promo, .lsl-nv__loc')) { drag = null; return; }
      const t = e.touches[0];
      drag = { x: t.clientX, y: t.clientY, dx: 0, dir: '', el: openLi ? panelOf(openLi) : n, p: !!openLi };
    }, { passive: true });
    n.addEventListener('touchmove', e => {
      if (!drag) return;
      const t = e.touches[0], dx = t.clientX - drag.x, dy = t.clientY - drag.y;
      if (!drag.dir) { if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return; drag.dir = Math.abs(dx) > Math.abs(dy) * 1.3 ? 'h' : 'v'; }
      if (drag.dir !== 'h') return;
      drag.dx = drag.p ? Math.max(0, dx) : Math.min(0, dx);
      n.classList.add('is-drag');
      drag.el.style.transform = 'translateX(' + drag.dx + 'px)';
    }, { passive: true });
    const endDrag = () => {
      if (!drag) return;
      const d = drag; drag = null;
      n.classList.remove('is-drag');
      d.el.style.transform = '';
      if (d.dir !== 'h') return;
      if (d.p && d.dx > 80) closeP();
      else if (!d.p && d.dx < -80) closeM();
    };
    n.addEventListener('touchend', endDrag, { passive: true });
    n.addEventListener('touchcancel', endDrag, { passive: true });

    if (q) {
      q.addEventListener('input', () => {
        const v = q.value.trim(); qx.hidden = !q.value; clearTimeout(tq);
        if (v.length < 2) { if (ctrl) ctrl.abort(); lastQ = ''; n.classList.remove('has-q'); res.innerHTML = ''; st.textContent = ''; return; }
        tq = setTimeout(() => search(v), 180);
      });
      qx.addEventListener('click', () => { clearQ(); q.focus(); });
    }

    /* Le fond suit la taille du panneau ouvert (aperçu qui change, images chargées) */
    if ('ResizeObserver' in window) { const ro = new ResizeObserver(() => { if (cur && isD()) place(cur); }); n.querySelectorAll('.lsl-nv__p').forEach(p => ro.observe(p)); }

    const l1 = n.querySelector('.lsl-nv__l1');
    if (l1) l1.addEventListener('scroll', () => { if (!isD()) return; if (cur) place(cur); if (n.classList.contains('is-lit')) blade(cur || activeLi()); }, { passive: true });

    if (isD()) { if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { if (isD() && !cur) rest(); }); else rest(); }
  }

  /* Écouteurs posés une seule fois sur la page */
  document.addEventListener('click', e => {
    if (!nav) return;
    const b = e.target.closest('[aria-controls="lsl-nav"]');
    if (b && !nav.contains(b)) { e.preventDefault(); if (nav.classList.contains('is-open')) closeM(); else openM(); return; }
    if (e.target.closest('[data-nv-scrim]')) { closeM(); return; }
    if (isD() && cur && !nav.contains(e.target)) { closeD(); rest(); }
  });
  document.addEventListener('keydown', e => {
    if (!nav || e.key !== 'Escape') return;
    if (isD() && cur) { const t = togOf(cur); closeD(); rest(); if (t && nav.contains(document.activeElement)) t.focus(); e.preventDefault(); }
    else if (!isD() && nav.classList.contains('is-open')) { e.preventDefault(); if (nav.classList.contains('has-q')) { clearQ(); q.focus(); } else if (openLi) closeP(); else closeM(); }
  });
  let tr = 0;
  addEventListener('resize', () => {
    if (!nav) return;
    cancelAnimationFrame(tr);
    tr = requestAnimationFrame(() => { if (!isD()) return; if (cur) place(cur); if (nav.classList.contains('is-lit')) blade(cur || activeLi()); });
  });
  mqD.addEventListener('change', () => { if (!nav) return; closeM(true); closeD(); nav.classList.remove('is-lit'); if (isD()) rest(); });
  addEventListener('pageshow', e => { if (e.persisted && nav) { closeM(true); closeD(); } });

  /* Le bouton menu du header (prévu pour le tiroir du thème) ouvre maintenant ce menu */
  const ICON = '<svg class="lsl-nv-bi" viewBox="0 0 24 22" aria-hidden="true" focusable="false"><rect class="h" x="1" y="4" width="5" height="2.4" rx="1"/><rect class="b b1" x="6.5" y="4.5" width="16" height="1.4" rx=".7"/><rect class="h" x="1" y="9.8" width="5" height="2.4" rx="1"/><rect class="b b2" x="6.5" y="10.3" width="16" height="1.4" rx=".7"/><rect class="h" x="1" y="15.6" width="5" height="2.4" rx="1"/><rect class="b b3" x="6.5" y="16.1" width="16" height="1.4" rx=".7"/></svg>';
  const takeBurger = () => document.querySelectorAll('[aria-controls="header-sidebar-menu"]').forEach(b => {
    if (document.getElementById('header-sidebar-menu')) return;
    b.setAttribute('aria-controls', 'lsl-nav'); b.setAttribute('aria-expanded', 'false'); b.classList.add('lsl-nv-burger');
    const s = b.querySelector('svg'); if (s) s.outerHTML = ICON;
  });

  const init = () => { const n = document.getElementById('lsl-nav'); takeBurger(); if (n && !n.dataset.ready) { n.dataset.ready = '1'; bind(n); } };
  init();
  /* Éditeur de thème : la section est rechargée */
  document.addEventListener('shopify:section:load', () => { html.classList.remove('lsl-nv-on'); init(); });
})();
